<!-- <h2>{{ appData[0]?.AppName }}</h2> -->
<div style="        margin: 1% 0%;
    
    padding: 18px 15px;
   
   background-color:white ;">
    <form class="example-form" [formGroup]="appForm" (ngSubmit)="onSubmit()">
        @if (placementCheck.status) {
        <mat-error class="error label-color-error">Placement already assigned to {{placementCheck.appName}}</mat-error>
        }
        @if (cpamAppIDCheck.status) {
        <mat-error class="error label-color-error">CPAM App ID already assigned to
            {{cpamAppIDCheck.appName}}</mat-error>
        }
        <table class="example-full-width" cellspacing="0">
            <tr>
                <td><mat-form-field class="example-full-width">
                        <mat-label>Application Name</mat-label>
                        <input matInput formControlName="appName">
                    </mat-form-field></td>
            </tr>
        </table>
        <div formArrayName="apps">

            <div [formGroupName]="i" *ngFor="let item of getApps.controls; let i = index">

                <h5 style="margin: 0% 0%;padding-bottom: 1%;">{{item.get('Type')?.value | titlecase}}</h5>

                <table class="example-full-width" cellspacing="0">
                    <!-- <tr>
                        <td><mat-form-field class="example-full-width">
                                <mat-label>Application Name</mat-label>
                                <input matInput formControlName="AppName">
                            </mat-form-field></td>
                    </tr> -->
                    <!-- <tr>
                    </tr> -->
                    <!-- <tr>
                        <mat-divider></mat-divider>
                    </tr> -->
                    <tr>
                        <td ><mat-form-field class="example-full-width">
                                <mat-label>OKTA SSO Url</mat-label>
                                <input matInput formControlName="OktaSsoUrl">
                            </mat-form-field></td>
                            <td>
                                <mat-slide-toggle style="margin: 0% 1%;" color="primary"
                                    formControlName="IsActive">Active</mat-slide-toggle>
            
                            </td>
                    </tr>
                </table>
            </div>
        </div>
        <mat-divider></mat-divider>
        <table style="margin-top: 2%;" class="example-full-width">
            <!-- desktop view -->
            @if (!isMobile) {
            <tr>
                <td>
                    <mat-form-field class="example-full-width">
                        <mat-label>Placement</mat-label>
                        <input matInput formControlName="placement" />
                    </mat-form-field>
                </td>
                <td>
                    <mat-form-field class="example-full-width">
                        <mat-label>CPAM Application ID</mat-label>
                        <input matInput formControlName="cpamAppId">
                    </mat-form-field>
                </td>
                <!-- <td>
                    <mat-slide-toggle style="margin: 0% 1%;" color="primary"
                        formControlName="isActive">Active</mat-slide-toggle>

                </td> -->
            </tr>
            }
            <!-- mobile view -->
            @else{
            <tr>
                <td>
                    <mat-form-field class="example-full-width">
                        <mat-label>Placement</mat-label>
                        <input matInput formControlName="placement" />
                    </mat-form-field>
                </td>
            </tr>
            <tr>
                <td>
                    <mat-form-field class="example-full-width">
                        <mat-label>CPAM Application Id</mat-label>
                        <input matInput formControlName="cpamAppId">
                    </mat-form-field>
                </td>

            </tr>
            <!-- <tr>
                <td>
                    <mat-slide-toggle style="margin: 0% 1%;" color="primary"
                        formControlName="IsActive">Active</mat-slide-toggle>

                </td>
            </tr> -->
            }
        </table>
        <div style="display: flex;
    justify-content: end;
    padding: 0% 1%;
    margin-top: 16%;">
                <button matButton="filled" mat-raised-button color="primary" class="cp-btn-submit" type="submit"
                [disabled]="!(appForm.valid && appForm.controls['apps'].valid && !placementCheck.status && !cpamAppIDCheck.status)">Save</button>
            <button mat-raised-button color="Secondary" class="cp-btn-cancel" (click)="onCancel()">Cancel</button>
        </div>


    </form>

    <br />
    <!-- <h5>{{`For ${userTypeEnum.external} Users` | titlecase}}</h5>
    <form class="example-form" [formGroup]="appForm">
         <table class="example-full-width" cellspacing="0">
            <tr>
                <td><mat-form-field class="example-full-width">
                        <mat-label>Application Name</mat-label>
                        <input matInput>
                    </mat-form-field></td>
                <td><mat-form-field class="example-full-width">
                        <mat-label>Placement</mat-label>
                        <input matInput>
                    </mat-form-field></td>
            </tr>
            <tr>

                <td><mat-form-field class="example-full-width">
                        <mat-label>CPAM Application Id</mat-label>
                        <input matInput>
                    </mat-form-field></td>
                <td>
                    <mat-slide-toggle style="    margin: 0% 1%;">Active</mat-slide-toggle>
                </td>
            </tr>
            <tr>
                <td colspan="2"><mat-form-field class="example-full-width">
                        <mat-label>OKTA SSO Url</mat-label>
                        <input matInput>
                    </mat-form-field></td>
            </tr>
        </table>
    </form> -->
</div>